import axios from "axios";

// Interceptors globales sobre la instancia default de axios: casi todo el
// resto del código (src/service/*.js y páginas que llaman axios directo)
// hace `import axios from "axios"` sin crear una instancia propia, así que
// registrando esto una sola vez al arrancar la app (ver src/index.js) queda
// cubierta cualquier llamada existente, sin tener que tocar cada archivo.

const HOST_API = process.env.REACT_APP_URL;

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}").token || null;
  } catch {
    return null;
  }
};

axios.interceptors.request.use((config) => {
  const isOwnApi = !config.url || config.url.startsWith("/") || (HOST_API && config.url.startsWith(HOST_API));
  const token = isOwnApi ? getToken() : null;

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Token ausente/invalido/expirado: mismo localStorage.clear() que usa
      // el logout manual (AppMenu.js). No se puede usar useNavigate acá
      // porque este archivo vive fuera del árbol de React.
      localStorage.clear();
      window.location.hash = "#/login";
    }

    return Promise.reject(error);
  }
);
